import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonLabel, IonLoading, IonPage, IonSelect, IonSelectOption, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack, tabletPortraitOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { listaEquipePorPerfil } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import '../ConfiguracoesLayout.css';
import './TotemConfiguracoes.css';

const TotemConfiguracoes: React.FC = () => {
    const history = useHistory();
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

    const [listaTotens, setListaTotens] = useState<any[]>([]);
    const [totemSelecionado, setTotemSelecionado] = useState<string>("");
    const [showLoading, setShowLoading] = useState(true);
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
    });

    useEffect(() => {
        const salvo = window.localStorage.getItem("totemSelecionado") || "";
        setTotemSelecionado(salvo);
        carregarTotens();
    }, []);

    async function carregarTotens() {
        try {
            setShowLoading(true);
            const token = window.localStorage.getItem("token") || "";
            const montarUrl = listaEquipePorPerfil.url
                .replace("{loja}", loja.replaceAll(/#/g, "%23"))
                .concat("?status=ativo&lojas=" + Buffer.from(loja).toString('base64'));

            const resp = await fetch(montarUrl.replace("{perfil}", "totem"), {
                method: "GET",
                headers: [["token", token]],
                credentials: 'include'
            });

            if (resp.status === 400 || resp.status === 401) {
                history.replace("/login/");
                return;
            }

            const result = await resp.json();
            if (result?.Items) {
                setListaTotens(result.Items);
            }
        } catch (e) {
            console.error("Erro ao carregar totens:", e);
        } finally {
            setShowLoading(false);
        }
    }

    function salvar() {
        if (!totemSelecionado) {
            setTextToast("Selecione um totem.");
            setShowToast(true);
            return;
        }

        const totem = listaTotens.find((t: any) => t.pk === totemSelecionado);
        window.localStorage.setItem("totemSelecionado", totemSelecionado);
        window.localStorage.setItem("totemSelecionadoNome", totem?.nome || "Totem");

        setTextToast("Totem salvo com sucesso.");
        setShowToast(true);
        history.goBack();
    }

    return (
        <IonPage className="totem-config-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="config-layout-toolbar">
                    <IonButtons slot="start">
                        <IonButton aria-label="Voltar" onClick={() => { history.goBack(); }}>
                            <IonIcon slot="icon-only" icon={arrowBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Configurações Totem</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="config-layout-content">
                <main className="config-container">
                    <div className="config-heading">
                        <h1>Configurações do Totem</h1>
                        <p>Escolha o totem que será utilizado neste dispositivo.</p>
                    </div>
                    <section className="config-card" aria-labelledby="totem-config-section-title">
                        <div className="totem-config-section-heading">
                            <span className="totem-config-icon"><IonIcon icon={tabletPortraitOutline} aria-hidden="true" /></span>
                            <div>
                                <h2 id="totem-config-section-title">Totem de atendimento</h2>
                                <p>Selecione uma opção e confirme para usar este totem.</p>
                            </div>
                        </div>
                        <div className="config-field totem-config-field">
                            <IonLabel className="config-label" id="totem-config-label">Totem selecionado</IonLabel>
                            <IonSelect
                                aria-labelledby="totem-config-label"
                                interface="popover"
                                interfaceOptions={{ cssClass: 'totem-config-options' }}
                                placeholder="Selecione o totem"
                                value={totemSelecionado}
                                onIonChange={(e) => setTotemSelecionado(e.detail.value)}
                            >
                                {listaTotens.map((totem: any) => (
                                    <IonSelectOption key={totem.pk} value={totem.pk}>
                                        {totem.nome || totem.pk}
                                    </IonSelectOption>
                                ))}
                            </IonSelect>
                        </div>
                    </section>
                </main>

                <IonLoading isOpen={showLoading} spinner='circles' />
                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>

            <IonFooter className="ion-no-border config-footer">
                <div className="config-footer-actions">
                    <IonButton className="config-primary totem-config-confirm" onClick={salvar}>
                        Confirmar
                    </IonButton>
                </div>
            </IonFooter>
        </IonPage>
    );
};

export default TotemConfiguracoes;
